import React from 'react'
import './Page.css'
import { FaYoutube, FaTelegramPlane, FaWhatsapp,} from 'react-icons/fa';
import Banner from '../Image/banner.png'
import LinkedIn from '../Image/linkedIn.png'
import Instagram from '../Image/instagram.png'
import tiktok from '../Image/tiktok.png'
import facebook from '../Image/facebook.png'
import whatsapp from '../Image/whatsapp.png'
import telegram from '../Image/telegram.png'


const SocialPage = () => {
  return (
    <div className="page-container">
      {/* Welcome Banner */}
      <div className="banner">
        <img src={Banner} alt="Welcome Banner" className="banner-image" />
      </div>
      
      <hr />

      {/* YouTube Subscription Section */}
      <section className="subscribe-section">
        <h2>Subscribe to Our YouTube Channel</h2>

          {/* Embedded YouTube Video */}
            <div className="youtube-video-container">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/AlMyBXqAAnc?si=WZCdeTNJSipFQP_V"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>

        <p>Subscribe to our YouTube channel for video updates!</p>
        <button className="youtube-button">
          <a href="https://www.youtube.com/@shinefirst" target="_blank" rel="noopener noreferrer">
            <FaYoutube /> Visit YouTube Channel
          </a>
        </button>
      </section>

      <hr />

      {/* Channels Section */}
      <section className="channels-section">
        <h2>Join Our Community Channels</h2>
        <p>Get daily updates, income reports, and achievement stories from our students!</p>
        <p className="recommendation-text">Recommended: Follow our Telegram for quick updates!</p>
        <div className="channel-buttons">
        <button className="telegram-button">
            <a href="https://t.me/shinefirst_updates" target="_blank" rel="noopener noreferrer">
              <FaTelegramPlane /> Join Our Telegram Channel
            </a>
          </button>
          <button className="whatsapp-button">
            <a href="https://whatsapp.com/channel/0029VanXpVQJkK7FTiFbWH3M" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> Join Our WhatsApp Channel
            </a>
          </button>
        </div>
      </section>

      <hr />

      {/* Customer Support Section */}
      <section className="support-section">
        <h2>Contact Our Customer Support</h2>
        <p>We’re here to assist you!</p>
        
        <div className="support-icons">
          <a href="https://wa.me/message/T3JIXKLQ3M6XE1" target="_blank" rel="noopener noreferrer">
            <img src={whatsapp} alt="WhatsApp Support" />
          </a>
          <a href="https://t.me/shinefirstlk" target="_blank" rel="noopener noreferrer">
            <img src={telegram} alt="Telegram Support" />
          </a>
        </div>
      </section>

      <hr />

      {/* Social Media Links Section */}
      <section className="social-media-section">
        <h2>Follow Us on Other Social Media</h2>
        
        <div className="social-icons">
          <a href="https://www.instagram.com/shine_first_lk/" target="_blank" rel="noopener noreferrer">
            <img src={Instagram} alt="Instagram" />
          </a>
          <a href="https://www.tiktok.com/@shinefirstlk" target="_blank" rel="noopener noreferrer">
            <img src={tiktok} alt="TikTok" />
          </a>
          <a href="https://www.linkedin.com/company/shinefirst/" target="_blank" rel="noopener noreferrer">
            <img src={LinkedIn} alt="LinkedIn" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61567469752550&_rdc=1&_rdr" target="_blank" rel="noopener noreferrer">
            <img src={facebook} alt="Facebook" />
          </a>
        </div>
      </section>
    </div>
  )
}

export default SocialPage
